import styled, { css } from "styled-components";

export const NoteTextContainer = styled.div`
  font-family: "museo sans";
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;

  ${props => css`
    color: ${props.color};
  `}
`;
